<template>
	<div class="bb-panel-wrapper">
		<section class="export-section">
			<span class="b360-form-label" role="heading">Export</span>
			<div class="">
				<a class="export-card" @click="downloadVideo()">
					<span class="export-card-image"
						><font-awesome-icon :icon="['fal', 'cloud-download']"
					/></span>
					<span class="export-card-type">Download Video</span>
				</a>
				<!--
          <ExportCard icon="cloud-download" icon-weight="fal" card-text=".mp4" :key="index" :filePath="downloadUrl" class="b360-col-xs-12 b360-col-6" @click="downloadVideo()" />
-->
			</div>
		</section>
		<!-- Turning off Sharing Video until this is functionality is working. -->
		<!--
    <section class="share-section">
        <span class="b360-form-label" role="heading">Share</span>
        <div class="social-share-container">
            <SocialBar v-for="(socialType, index) in socialArray" :socialType="socialType" :icon="socialType.icon" :icon-weight="socialType.iconWeight" :social-name="socialType.socialName" :key="index" />
        </div>
    </section>
    <button class="b360-btn--workspace-primary">Post</button>
    -->
	</div>
</template>

<script>
import ExportCard from '@/components/brand-builder/ExportCard.vue';
import SocialBar from '@/components/brand-builder/SocialBar.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import * as htmlToImage from 'html-to-image';
import apiClient from '@/services/api-client';
import download from 'downloadjs';
import partnerPointsApi from '@/services/Lopp/partner-points-service';

export default {
	name: 'BbVideoExport',
	data() {
		return {
			downloadUrl: '',
			width: null,
			height: null,
		};
	},
	components: {
		ExportCard,
		SocialBar,
	},
	computed: {
		...mapGetters(['partnerPointsProfile']),
		...mapState({
			selectedDesign: (state) => {
				if (state.brandBuilderEditor.selectedDesign) {
					return state.brandBuilderEditor.selectedDesign;
				}

				return '';
			},
			videoExportTypeArray: (state) =>
				state.brandBuilderEditor.videoExportTypeArray,
			socialArray: (state) => state.brandBuilderEditor.socialArray,
			completeVideo: (state) => state.brandBuilderEditor.completeVideo,
			selectedVideo: (state) => state.brandBuilderEditor.selectedVideo,
			videoIsVertical: (state) => state.brandBuilderEditor.videoIsVertical,
		}),
	},
	methods: {
		...mapActions(['selectSocialType', 'completeVideoAction', 'toggleLoader']),

		transformMedia(
			baseVideo,
			encodedMedia,
			startOffset,
			endOffset,
			x,
			y,
			width,
			height,
		) {
			return apiClient()
				.post('/TransformMedia/TransformMedia', {
					baseVideo,
					encodedMedia,
					startOffset,
					endOffset,
					x,
					y,
					width,
					height,
				})
				.then((response) => {
					this.completeVideoAction(response.data.transformUrl);
					this.downloadUrl = response.data.transformUrl;
					window.open(this.downloadUrl);
				})
				.catch((error) => {
					console.log(error.response);
				});
			// TODO : this should be done through the services Jon mentioned
		},
		makeVideo(videoToTransform, start, stop) {
			/*      baseVideo,
                    mediaByteArray,
                    startOffset,
                    endOffset,
                    transformUrl, */

			document.getElementById('item-container').style.marginTop = '0px';

			htmlToImage
				.toPng(document.getElementById('item-container'), {
					backgroundColor: '#fff',
					quality: 1,
					opacity: 0.5,
					pixelRatio: 1,
				})
				.then((dataURI) => {
					const strippedString = dataURI.replace('data:image/png;base64,', '');
					this.transformMedia(
						videoToTransform,
						strippedString,
						start,
						stop,
						0,
						0,
						this.width,
						this.height,
					);
					// This allows the title card to scale to 1 for the video, instead of using the viewport scale.
					document
						.getElementById('item-container')
						.classList.remove('fullscale');
					this.toggleLoader();
				});
		},
		downloadVideo() {
			// export Video button triggers the download method.
			const { campaignType, mediaType } = this.partnerPointsProfile(),
				exportType = '.mp4';
			partnerPointsApi.toolboxAddPointsAsync(
				campaignType,
				mediaType,
				exportType,
			);

			if (this.completeVideo) {
				window.open(this.completeVideo);
			} else {
				const startUrl = this.selectedDesign.item.medias[
					this.selectedVideo
				].uri.replace('https://res.cloudinary.com/uwm/video/upload/', '');
				const regex = /[a-zA-Z0-9]*/;
				const finalVideoUrl = startUrl.replace(regex, '');
				// This makes the video scale to 1 for proper implemenation of title card in Video.
				document.getElementById('item-container').classList.add('fullscale');

				// Keeps the relation of this in the nested functions.
				let _this = this;

				this.toggleLoader();
				// create the target item for the scale check
				const targetScale = document.getElementById('item-container');
				// Set the target check to an interval
				const interval = setInterval(makeVideoCall, 250);

				function makeVideoCall() {
					// This gets the current scale of the title card.
					const compStyle = window.getComputedStyle(targetScale);
					const transformValue = compStyle.getPropertyValue('transform');

					// If the interval does not produce the scale of 1 result redo the interval and once the scale of 1 is confirmed proceed to the htmlToImage checks
					if (transformValue !== 'matrix(1, 0, 0, 1, 0, 0)') {
						return;
					}
					clearInterval(interval);

					// Now that the scale is correct create the stitching for the video
					_this.makeVideo(
						finalVideoUrl,
						_this.selectedDesign.item.medias[_this.selectedVideo].mediaTransform
							.startOffset,
						_this.selectedDesign.item.medias[_this.selectedVideo].mediaTransform
							.endOffSet,
					);
				}
			}
		},
	},
	mounted() {
		if (this.completeVideo !== '') {
			this.downloadUrl = this.completeVideo;
		} else {
			const startUrl = this.selectedDesign.item.medias[
				this.selectedVideo
			].uri.replace('https://res.cloudinary.com/uwm/video/upload/', '');
			const regex = /[a-zA-Z0-9]*/;
			const finalVideoUrl = startUrl.replace(regex, '');
			if (this.videoIsVertical) {
				this.height = 1920;
				this.width = 1080;
			}

			// this.makeVideo(finalVideoUrl, 20, 26);
			//todo : this needs to be a property on the media coming in from the back end
		}
	},
};
</script>

<style lang="scss" scoped>
.export-card-container {
	@include rem('grid-gap', 20px);
}

.social-share-container {
	@include rem('margin-bottom', 30px);
}

.social-bar {
	& + & {
		@include rem('margin-top', 10px);
	}
}

.export-card {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: $off-white;
	border-radius: $b360-border-radius-base;
	border: $b360-border-width-thin $border-color-light solid;
	@include rem('padding', 9px 15px);
	text-decoration: none;
	box-shadow: none;
	transition: $b360-motion-selection;
	cursor: pointer;

	&:hover {
		border-color: $b360-color--gray__medium;
		box-shadow: 0 0 6px $shadow-color;
	}
}

.export-card-image {
	@include rem('font-size', 26px);
	@include rem('margin-right', 16px);
	color: $brand-teal;
}

.export-card-type {
	font-size: $b360-font-size--base;
	color: $text-base-color;
	font-weight: 500;
}
</style>
